// Re-exporta la ventana única y estándar de búsqueda de personas.
import PersonSearch from "../PersonSearch";

export default PersonSearch;
